import { Observable } from "rxjs";
import { BaseNutrientService } from "./interfaces/nutrient-service.interface";

export abstract class AbstractNutrientService implements BaseNutrientService {
  abstract load(): Observable<any>;
}
